/**
 * Role badge — Admin in the gold token, Staff in the mint token (DESIGN.md §5),
 * matching the sidebar's active/accent palette.
 */
export default function RoleBadge({ role, className = "" }) {
  const isAdmin = role === "admin";
  return (
    <span
      className={`inline-flex items-center rounded-md px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider ${
        isAdmin
          ? "bg-primary-fixed text-on-primary-fixed-variant"
          : "bg-tertiary-fixed text-on-tertiary-fixed-variant"
      } ${className}`}
    >
      {isAdmin ? "Admin" : "Staff"}
    </span>
  );
}
